<template>
	<div class="decodeWrap valueTd">
		<span class="valueTd__svg icon_dollars">$</span>
		<span>{{ decodedValue }}</span>
	</div>
</template>

<script>
export default {
	name: "DeCode",

	props: {
		item: {
			type: Object,
			default: () => ({})
		},

		line: {
			type: Object,
			default: () => ({})
		}
	},

	computed: {
		/**
		 * Returns decoded Base64 value.
		 *
		 * @returns {String} Decoded value.
		 */
		decodedValue() {
			const value = this.line[this.item.value];

			if (!value) {
				return "";
			}

			return this.decodeBase64(value);
		}
	},

	methods: {
		/**
		 * Decodes Base64 string to UTF-8.
		 *
		 * @param {String} value Base64 encoded value.
		 * @returns {String} Decoded string.
		 */
		decodeBase64(value) {
			try {
				const base64 = value
					.replace(/-/g, "+")
					.replace(/_/g, "/");

				const binary = atob(base64);
				const bytes = Uint8Array.from(
					binary,
					char => char.charCodeAt(0)
				);

				const decoded = new TextDecoder("utf-8").decode(bytes);

				return this.formatDecodedValue(decoded);
			} catch (error) {
				return value;
			}
		},

		/**
		 * Formats decoded JSON if possible.
		 *
		 * @param {String} value Decoded value.
		 * @returns {String} Formatted value.
		 */
		formatDecodedValue(value) {
			try {
				const parsed = JSON.parse(value);

				return JSON.stringify(parsed, null, 2);
			} catch (error) {
				return value;
			}
		}
	}
};
</script>

<style scoped lang="scss">
.decodeWrap {
	width: 100%;

	span {
		white-space: pre-wrap;
		word-break: break-word;
	}
}
</style>
